export const SET_DASHBOARDS = "setDashboards";
export const CLEAR_DASHBOARDS = "clearDashboards";
export const SET_DASHBOARD = "setDashboard";
export const CLEAR_DASHBOARD = "clearDashboard";
export const SET_NAME = "setName";
export const REMOVE_DASHBOARD = "removeDashboard";
export const ADD_DASHBOARD = "addDashboard";
export const ADD_CHART = "addChart";
export const REMOVE_CHART = "removeChart";
export const SET_PERIOD = "setPeriod";
export const SET_COMPARE_SURVEYS = "setCompareSurveys";
export const SET_GENERAL_METRIC = "setGeneralMetric";
export const SET_METRICS = "setMetrics";
export const ADD_METRIC = "addMetric";
export const SET_SURVEYS = "setSurveys";
export const REMOVE_SURVEY = "removeSurvey";
export const SET_COMPOSITE_METRICS = "setCompositeMetrics";
export const ADD_SELECTED_ITEM = "addSelectedItem";
export const REMOVE_SELECTED_ITEM = "removeSelectedItem";
export const SET_FILTER_DATES = "setFilterDates";
export const SET_FILTER_CHANNEL = "setFilterChannel";
export const REMOVE_FILTER_CHANNEL = "removeFilterChannel";
export const SET_FILTER_METADATA = "setFilterMetadata";
export const SET_FILTER_ANSWER_STATUS = "setFilterAnswerStatus";
export const SET_DESIGN = "setDesign";
export const UPDATE_CHART = "updateChart";
export const UPDATE_CHART_LAYOUT = "updateChartLayout";
export const SET_LAYOUT = "setLayout";
export const SET_CHART_NAME = "setChartName";
export const SET_CHARTS = "setCharts";
export const SET_CHART_COMPONENT = "setChartComponent";
